import {SeasonName} from '@Libraries/seasons.library';
import {isBrandKitsHalloweenSeason} from '@Libraries/brands-library';
import {getBrandsHalloweenPopupText} from '@Libraries/brands-library';
import {isChristmasSeason} from '@Utils/seasonal-promotion.util';

// Marketing asked for no seasonal brand-kit popovers for the 2026 season. Flip this to bring them back.
const IS_SEASONAL_BRANDKIT_POPOVER_ENABLED = false;

export const isSeasonalBrandkitPopoverEnabled = (): boolean => {
  return IS_SEASONAL_BRANDKIT_POPOVER_ENABLED;
};

export const getEndpointForGetUserHasSeenSeasonalBrandkit = (season: SeasonName): string => {
  switch (season) {
    case SeasonName.HALLOWEEN:
      return 'brand/getUserHasSeenHalloweenBrandkitPopover';
    default:
      throw new Error(`Unhandled season ${season}`);
  }
};

export const getEndpointForSetUserHasSeenSeasonalBrandkit = (season: SeasonName): string => {
  switch (season) {
    case SeasonName.HALLOWEEN:
      return 'brand/setUserHasSeenHalloweenBrandkitPopover';
    default:
      throw new Error(`Unhandled season ${season}`);
  }
};

export const getImageFilenameForSeasonalBrandkitPopover = (season: SeasonName): string => {
  switch (season) {
    case SeasonName.HALLOWEEN:
      return 'halloween-brandkit-popover';
    default:
      throw new Error(`Unhandled season ${season}`);
  }
};

export const getTextForSeasonalBrandkitPopover = (season: SeasonName): string => {
  switch (season) {
    case SeasonName.HALLOWEEN:
      return getBrandsHalloweenPopupText();
    default:
      throw new Error(`Unhandled season ${season}`);
  }
};

export const isSeasonCurrentlyActive = (season: SeasonName): boolean => {
  switch (season) {
    case SeasonName.HALLOWEEN:
      return isBrandKitsHalloweenSeason();

    case SeasonName.CHRISTMAS:
      return isChristmasSeason();

    default:
      throw new Error(`Unhandled season ${season}`);
  }
};

export const doesSeasonHaveBrandkit = (season: SeasonName): boolean => {
  switch (season) {
    case SeasonName.HALLOWEEN:
      return true;
    case SeasonName.CHRISTMAS:
      return false;
    default:
      throw new Error(`Unhandled season ${season}`);
  }
};
